/* eslint-disable */
import { PRIMARY_SCHOOL_TYPES, COLLEGE_SCHOOL_TYPES } from "@/config/Constants";

export const getMenuData = [
  {
    category: true,
    title: "menu.generale",
    key: "home",
    accessGroup: "home",
    access: ["home", "all"],
  },
  {
    title: "menu.statistique", //acceuil
    key: "home",
    accessGroup: "home",

    icon: "fa fa-pie-chart",
    access: ["statstiqueGeneral", "usersStats", "bulletin", "home", "all"],

    children: [
      {
        title: "menu.generale",
        key: "generale-statistique",
        accessGroup: "home",
        url: "/accueil",
        icon: "fa fa-home",
        access: ["all", "statstiqueGeneral"],
        buildingAccess: "statstiqueGeneral",
      },
      {
        title: "menu.financialStats",
        key: "financier-statistique",
        accessGroup: "home",
        url: "/financial-statistics",
        icon: "fa fa-pie-chart",
        access: ["all"],
        buildingAccess: "financialStats",
      },
      {
        title: "bulletin.bulletinV1",
        key: "bulletinStatistique",
        accessGroup: "bulletin",
        version: "v1",
        icon: "fa fa-file-text",
        url: "/bulletinStatistique",
        access: ["all", "statistique"],
        buildingAccess: "bulletinStatistique",
        schoolTypes: PRIMARY_SCHOOL_TYPES,
      },

      {
        title: "menu.bulletin",
        key: "bulletinStatistiqueV2",
        accessGroup: "bulletin",
        version: "v2",
        icon: "fa fa-file-text",
        url: "/bulletinStatistiqueV2",
        access: ["all", "statistique"],
        buildingAccess: "bulletinStatistique",
        schoolTypes: PRIMARY_SCHOOL_TYPES,
      },
      {
        title: "menu.connection",
        key: "connection-statistique",
        accessGroup: "home",
        url: "/connected",
        icon: "fa fa-user",
        access: ["all", "usersStats"],
        buildingAccess: "usersStats",
      },
      /*
      {
        title: "menu.powerbi",
        key: "powerbi",
        accessGroup: "home",
        url: "/powerbi",
        icon: "fa fa-stat",
        access: ["all", "home"],
        buildingAccess: "statstiqueGeneral",
      },
*/
    ],
  },

  {
    category: true,
    title: "menu.parametrage",
    key: "parametrage",
    accessGroup: "parametrage",
    access: ["all", "etablissement", "comptabilite", "scolarite"],
  },

  {
    title: "menu.parametrage",
    key: "parametrage",
    accessGroup: "parametrage",
    icon: "fa fa-cogs",
    access: [
      "all",
      "etablissement",
      "comptabilite",
      "scolarite",
      "smart_schedule",
    ],
    children: [
      {
        title: "menu.etablissement",
        key: "etablissement",
        accessGroup: "parametrage",
        url: "/etablissement",
        icon: "fa fa-university",
        access: ["all", "etablissement"],
        buildingAccess: "parametrageEtablissement",
      },
      {
        title: "menu.comptabilite",
        key: "comptabilite",
        accessGroup: "parametrage",

        url: "/comptabilite",
        icon: "fa fa-sort-numeric-desc",
        access: ["all", "comptabilite"],
        buildingAccess: "parametrageComptabilite",
      },
      {
        title: "menu.scolarite",
        key: "scolarite",
        accessGroup: "parametrage",

        url: "/scolarite",
        icon: "fa fa-pencil",
        access: ["all", "scolarite"],
        buildingAccess: "parametrageScolarite",
      },
      {
        title: "menu.bulletin",
        key: "bulletin",
        accessGroup: "parametrage",

        url: "/bulletin",
        icon: "fa fa-file-text",
        access: ["all", "bulletin"],
        buildingAccess: "bulletin",
      },
      {
        title: "menu.smsAndNotifications",
        key: "smsp",
        accessGroup: "parametrage",

        url: "/sms-settings",
        icon: "fa fa-envelope",
        access: ["all", "sms"],
        buildingAccess: "sms",
      },
      /* {
         title: "menu.smartSchedule",
         key: "smartScheduleSettings",
         url: "/smartscheduleParams",
         icon: "fa fa-clock-o",
         accessGroup: "parametrage",
         access: ["all", "smart_schedule"],
         buildingAccess: "smartSchedule",
       },*/
    ],
  },
  {
    title: "menu.administration",
    key: "adminstration",
    accessGroup: "adminstration",

    icon: "fa fa-expeditedssl",
    access: ["all", "autorisation", "utilisateur"],
    children: [
      {
        title: "menu.autorisation",
        key: "autorisation",
        accessGroup: "adminstration",

        url: "/autorisation",
        icon: "fa fa-low-vision",
        access: ["all", "autorisation"],
      },
      {
        title: "menu.utilisateur",
        key: "utilisateur",
        accessGroup: "adminstration",

        url: "/utilisateur",
        icon: "fa fa-universal-access",
        access: ["all", "utilisateur"],
      },
    ],
  },
  {
    category: true,
    title: "menu.scolarite",
    key: "scolarite",
    accessGroup: "scolarite",

    access: ["all", "liste_eleves"],
  },
  {
    title: "menu.listeEleves",
    key: "liste_eleves",
    accessGroup: "liste_eleves",

    icon: "fa fa-database",
    url: "/elevesliste",
    access: ["all", "liste_eleves"],
    buildingAccess: "studentList",
  },
  {
    title: "pickup.title",
    key: "pickup",
    accessGroup: "liste_eleves",
    icon: "fa fa-car",
    url: "/pickup",
    access: ["all", "liste_eleves"],
  },

  {
    title: "menu.preinscription",
    key: "preinscription",
    accessGroup: "liste_eleves",

    icon: "fa fa-database",
    url: "/preinscription",
    access: ["liste_eleves"],
    buildingAccess: "preInscription",
  },

  {
    title: "menu.activites",
    key: "activite",
    accessGroup: "activite",

    icon: "fa fa-tags",
    access: ["all", "inscription", "etat_paiement", "cantine"],
    buildingAccess: "activites",

    children: [
      {
        title: "menu.inscriActiv",
        key: "inscriptionActivites",
        accessGroup: "activite",
        buildingAccess: "activites",
        url: "/inscriptionActivites",
        icon: "fa fa-mortar-board",
        access: ["all", "inscription"],
      },
      {
        title: "menu.emploiActivites",
        key: "emploiActivites",
        accessGroup: "activite",
        buildingAccess: "activites",
        url: "/emploiActivites",
        icon: "fa fa-calendar",
        access: ["all", "inscription"],
      },
      {
        title: "menu.assiduiteActivites",
        key: "assiduiteActivites",
        accessGroup: "activite",
        buildingAccess: "activites",
        url: "/assiduiteActivites",
        icon: "fa fa-check-square-o",
        access: ["all", "inscription"],
      },

      {
        title: "menu.etatPaiement",
        key: "etatPaiementActivite",
        accessGroup: "activite",
        buildingAccess: "activites",
        url: "/etatPaiementActivite",
        icon: "fa fa-money",
        access: ["all", "etat_paiement"],
      },
      {
        title: "menu.cantine",
        key: "cantine",
        accessGroup: "activite",

        url: "/cantine",
        icon: "fa fa-cutlery",
        access: ["all", "cantine"],
        buildingAccess: "cantine",
      },
    ],
  },

  {
    title: "menu.scolarite",
    key: "scolarite",
    accessGroup: "scolarite",

    icon: "fa fa-graduation-cap",
    access: ["all", "inscription", "etat_paiement", "punition"],
    buildingAccess: "scolarite",

    children: [
      {
        title: "menu.inscriScol",
        key: "inscriptionScolarité",
        accessGroup: "scolarite",
        buildingAccess: "scolarite",
        url: "/inscriptionScolarite",
        icon: "fa fa-book",
        access: ["all", "inscription"],
      },
      {
        title: "menu.etatPaiements",
        key: "etatDesImpayés",
        accessGroup: "scolarite",
        buildingAccess: "scolarite",
        url: "/etatDesImpayes",
        icon: "fa fa-money",
        access: ["all", "etat_paiement"],
      },
      {
        title: "menu.listePunition",
        key: "listeDesPunitions",
        accessGroup: "scolarite",

        url: "/listePunitions",
        icon: "fa fa-legal",
        access: ["all", "punition"],
        buildingAccess: "punishments",
      },
    ],
  },
  {
    title: "menu.emploi",
    key: "emplois",
    accessGroup: "emplois",

    icon: "fa fa-calendar",
    access: ["all", "eleves", "enseignant", "smart_schedules", "teacher_dispo"],
    buildingAccess: "emplois",

    children: [
      {
        title: "emploi.classe",
        key: "schedule",
        accessGroup: "emplois",
        buildingAccess: "emplois",
        url: "/schedule",
        icon: "fa fa-calendar",
        access: ["all", "eleves"],
      },
      {
        title: "menu.enseignants",
        key: "teacherschedule",
        accessGroup: "emplois",
        buildingAccess: "emplois",
        url: "/teacherschedule",
        icon: "fa fa-briefcase",
        access: ["all", "enseignant"],
      },
      /* {
         title: "smartSchedule.smartSchedules",
         key: "ssmartSchedule",
         accessGroup: "emplois",
         url: "/smart-schedule",
         icon: "fa fa-calendar-check-o",
         access: ["all", "smart_schedules"],
         buildingAccess: "smartSchedule",
       },*/
      {
        title: "menu.teacherAvailability",
        key: "teacherAvailability",
        accessGroup: "emplois",
        url: "/teacherAvailability",
        icon: "fa fa-clock-o",
        access: ["all", "teacher_dispo"],
        buildingAccess: "teacherAvailability",
      },
    ],
  },
  {
    title: "menu.assiduite",
    key: "assiduite",

    accessGroup: "assiduite",
    icon: "fa fa-th-list",
    url: "/attendance",
    access: ["all", "assiduite"],
    buildingAccess: "attendance",
  },
  {
    title: "menu.personnel",
    key: "personnel",
    accessGroup: "personnel",

    url: "/listePersonnel",
    icon: "fa fa-users",
    access: [
      "all",
      "personnel",
      "enseignant",
      "etat_paiement",
    ],
    buildingAccess: "personnel",

    children: [
      {
        title: "menu.listePersonnels",
        key: "listePersonnel",
        accessGroup: "personnel",
        buildingAccess: "personnel",
        url: "/listePersonnel",
        icon: "fa fa-suitcase",
        access: ["all", "personnel"],
      },
      {
        title: "menu.listeEnseignants",
        key: "listeEnseignant",
        accessGroup: "personnel",
        buildingAccess: "personnel",
        url: "/listeEnseignant",
        icon: "fa fa-briefcase",
        access: ["all", "enseignant"],
      },
      {
        title: "menu.etatPaiement",
        key: "etatDePaiement",
        accessGroup: "personnel",
        buildingAccess: "personnel",
        url: "/etatDePaiement",
        icon: "fa fa-book",
        access: ["all", "etat_paiement"],
      },
      {
        title: "menu.teacherAttendance",
        key: "teacherAttendance",
        accessGroup: "personnel",
        buildingAccess: "personnel",
        url: "/teacherAttendance",
        icon: "fa fa-clock-o",
        access: ["all", "enseignant", "personnel"],
      },
    ],
  },
  {
    category: true,
    title: "bulletin.bulletin",
    key: "bulletinCate",
    accessGroup: "bulletin",
    access: ["all", "pedagogic", "pilote", "specific"],
    buildingAccess: "bulletin",
    version: "v2",
  },
  {
    category: true,
    title: "bulletin.bulletinV1",
    key: "bulletinCate",
    accessGroup: "bulletin",
    access: ["all", "pedagogic", "pilote", "specific"],
    buildingAccess: "bulletin",
    version: "v1",
  },
  {
    title: "menu.accessTeacher",
    key: "accessTeacher",
    version: "v2",
    accessGroup: "personnel",
    icon: "fa fa-briefcase",
    url: "/teacherAccess",
    access: ["all", "enseignant"],
    buildingAccess: "personnel",
  },
  {
    title: "menu.bulletinCollege",
    key: "bulletinCollege",
    accessGroup: "bulletin",
    icon: "fa fa-file-text",
    url: "/bulletin/college/noteeleve",
    access: ["all", "pedagogic"],
    buildingAccess: "bulletin",
    schoolTypes: COLLEGE_SCHOOL_TYPES,
  },
  {
    title: "menu.bulletin",
    key: "bulletinv2",
    accessGroup: "bulletin",
    version: "v2",
    icon: "fa fa-file-text",
    access: ["all", "pedagogic"],
    buildingAccess: "bulletin",
    schoolTypes: PRIMARY_SCHOOL_TYPES,
    children: [
      {
        title: "bulletin.bulletinPedagogique",
        key: "bulletinPedagogiqueV2",
        buildingAccess: "bulletin",
        accessGroup: "bulletin",
        url: "/bulletinV2/bulletinPedagogique",
        icon: "fa fa-pencil",
        access: ["all", "pedagogic"],
      },
      {
        title: "bulletin.bulletinSpecifique",
        key: "bulletinSpecifiqueV2",
        buildingAccess: "bulletinPilote",
        accessGroup: "bulletin",
        url: "/bulletinV2/bulletinPilote",
        icon: "fa fa-pencil",
        access: ["all", "pilote"],
      },
      {
        title: "bulletin.bulletinVerySpecifique",
        key: "bulletinVerySpecifiqueVV2",
        buildingAccess: "bulletinSpecific",
        accessGroup: "bulletin",
        url: "/bulletinV2/bulletinVerySpecifique",
        icon: "fa fa-pencil",
        access: ["all", "specific"],
      },
    ],
  },
  {
    title: "bulletin.bulletinPedagogique",
    key: "bulletin",
    accessGroup: "bulletin",
    version: "v1",
    count: "-",
    icon: "fa fa-file-text",
    access: ["all", "pedagogic"],
    buildingAccess: "bulletin",
    children: [
      {
        title: "menu.notesModule",
        key: "notesM",
        accessGroup: "bulletin",
        buildingAccess: "bulletin",
        url: "/bulletin/notemodule",
        icon: "fa fa-pencil",
        access: ["all", "pedagogic"],
      },
      {
        title: "menu.notesModuleComplet",
        key: "notesC",
        accessGroup: "bulletin",
        buildingAccess: "bulletin",
        url: "/bulletin/notemodulecomplet",
        icon: "fa fa-pencil",
        access: ["all", "pedagogic"],
      },
      {
        title: "menu.notesParEleve",
        key: "notesE",
        accessGroup: "bulletin",
        buildingAccess: "bulletin",
        url: "/bulletin/noteeleve",
        icon: "fa fa-pencil",
        access: ["all", "pedagogic"],
      },
      {
        title: "appreciation.adminAppreciation",
        key: "APPadmin",
        accessGroup: "bulletin",
        buildingAccess: "bulletin",
        url: "/bulletin/appreciationAdmin",
        icon: "fa fa-pencil",
        access: ["all", "pedagogic"],
      },
      {
        title: "menu.certificate",
        key: "notesCC",
        accessGroup: "bulletin",

        url: "/bulletin/certification",
        icon: "fa fa-pencil",
        access: ["all", "pedagogic"],
        buildingAccess: "certificate",
      },
    ],
  },
  {
    title: "bulletin.bulletinSpecifique",
    key: "bulletinSpec",
    accessGroup: "bulletin",
    version: "v1",
    icon: "fa fa-file-text",
    access: ["all", "pilote"],
    buildingAccess: "bulletinPilote",
    children: [
      {
        title: "menu.notesModule",
        key: "specNotesM",
        accessGroup: "bulletin",
        buildingAccess: "bulletinPilote",
        url: "/specbulletin/notemodule",
        icon: "fa fa-pencil",
        access: ["all", "pilote"],
      },
      {
        title: "menu.notesModuleComplet",
        key: "specNotesC",
        accessGroup: "bulletin",
        buildingAccess: "bulletinPilote",
        url: "/specbulletin/notemodulecomplet",
        icon: "fa fa-pencil",
        access: ["all", "pilote"],
      },
      {
        title: "menu.notesParEleve",
        key: "specNotesE",
        accessGroup: "bulletin",
        buildingAccess: "bulletinPilote",
        url: "/specbulletin/noteeleve",
        icon: "fa fa-pencil",
        access: ["all", "pilote"],
      },
    ],
  },
  {
    title: "bulletin.bulletinVerySpecifique",
    key: "bulletinVerySpec",
    accessGroup: "bulletin",
    version: "v1",
    icon: "fa fa-file-text",
    access: ["all", "specific"],
    buildingAccess: "bulletinSpecific",
    children: [
      {
        title: "menu.notesModule",
        key: "specVNotesM",
        accessGroup: "bulletin",
        buildingAccess: "bulletinSpecific",
        url: "/veryspecbulletin/notematiere",
        icon: "fa fa-pencil",
        access: ["all", "specific"],
      },
      {
        title: "menu.notesModuleComplet",
        key: "specVNotesC",
        accessGroup: "bulletin",
        buildingAccess: "bulletinSpecific",
        url: "/veryspecbulletin/notemodule",
        icon: "fa fa-pencil",
        access: ["all", "specific"],
      },
      {
        title: "menu.notesParEleve",
        key: "specVNotesE",
        accessGroup: "bulletin",
        buildingAccess: "bulletinSpecific",
        url: "/veryspecbulletin/noteeleve",
        icon: "fa fa-pencil",
        access: ["all", "specific"],
      },
    ],
  },
  /*
    {
      category: true,
      title: "menu.comptabilite",
      key: "comptabilite",
      accessGroup: "comptabilite",
      buildingAccess: "comptabilite",
  
      access: [
        "all",
        "etat_recettes",
        "journale_caisse",
        "depenses",
        "etat_impayes",
        "liste_reglement",
        "reglement_annule",
      ],
    },
    
      {
        title: "menu.comptabilite",
        key: "comptabilite",
        accessGroup: "comptabilite",
        buildingAccess: "comptabilite",
        icon: "fa fa-money",
        access: [
          "all",
          "etat_recettes",
          "avance",
          "journale_caisse",
          "depenses",
          "etat_impayes",
          "liste_reglement",
          "reglement_annule",
        ],
        children: [
          {
            title: "menu.etatRecettes",
            key: "etatDesRecettes",
            accessGroup: "comptabilite",
            buildingAccess: "comptabilite",
    
            url: "/etatDesRecettes",
            icon: "fa fa-list",
            access: ["all", "etat_recettes"],
          },
          {
            title: "menu.journaleCaisse",
            key: "journalCaisse",
            accessGroup: "comptabilite",
            buildingAccess: "comptabilite",
    
            url: "/journalCaisse",
            icon: "fa fa-book",
            access: ["all", "journale_caisse"],
          },
          {
            title: "menu.caisseAvance",
            key: "avance",
            accessGroup: "comptabilite",
    
            url: "/caisseavance",
            icon: "fa fa-money",
            access: ["all", "avance"],
            buildingAccess: "comptabilite",
          },
    
          {
            title: "menu.depenses",
            key: "depenses",
            accessGroup: "comptabilite",
            buildingAccess: "comptabilite",
    
            url: "/depenses",
            icon: "fa fa-money",
            access: ["all", "depenses"],
          },
          {
            title: "menu.etatImpayes",
            key: "etatDesImpayes",
            accessGroup: "comptabilite",
            buildingAccess: "comptabilite",
    
            url: "/etatDesImpayesC",
            icon: "fa fa-money",
            access: ["all", "etat_impayes"],
          },
          {
            title: "menu.listeReglement",
            key: "listeReglement",
            accessGroup: "comptabilite",
            buildingAccess: "comptabilite",
    
            url: "/listeReglement",
            icon: "fa fa-money",
            access: ["all", "liste_reglement"],
          },
          {
            title: "menu.reglementsAnnules",
            key: "listeReglementAnnulé",
            accessGroup: "comptabilite",
            buildingAccess: "comptabilite",
    
            url: "/listeReglementAnnule",
            icon: "fa fa-money",
            access: ["all", "reglement_annule"],
          },
    
          {
            title: "menu.cheques",
            key: "cheque",
            accessGroup: "comptabilite",
            buildingAccess: "comptabilite",
    
            url: "/cheques",
            icon: "fa fa-money",
            access: ["all", "etat_recettes"],
          },
        ],
      },
      {
        title: "menu.declaration",
        key: "declaration",
        accessGroup: "declaration",
    
        icon: "fa fa-eye",
        access: [
          "all",
          "etat_impayesA",
          "etat_impayesS",
          "declarationTVA",
          "chiffre_affaire",
          "chiffre_affaireS",
        ],
        buildingAccess: "declaration",
    
        children: [
          {
            title: "menu.etatImpayesActivites",
            key: "etatImpayesActivites",
            accessGroup: "declaration",
    
            url: "/etatImpayesActivites",
            icon: "fa fa-info",
            access: ["all", "etat_impayesA"],
          },
          {
            title: "menu.etatImpayesScolarite",
            key: "etatImpayesScolarite",
            accessGroup: "declaration",
    
            url: "/etatImpayesScolarite",
            icon: "fa fa-eye",
            access: ["all", "etat_impayesS"],
          },
          {
            title: "menu.declarationTva",
            key: "declarationTVA",
            accessGroup: "declaration",
    
            url: "/declarationTVA",
            icon: "fa fa-type",
            access: ["all", "declarationTVA"],
          },
          {
            title: "menu.chiffreAffaires",
            key: "chiffreAffaire",
            accessGroup: "declaration",
    
            url: "/chiffreAffaire",
            icon: "fa fa-trending-up",
            access: ["all", "chiffre_affaire"],
          },
          {
            title: "menu.chiffreAffairesScolarite",
            key: "chiffreAffaireScolarite",
            accessGroup: "declaration",
    
            url: "/chiffreAffaireScolarite",
            icon: "fa fa-activity",
            access: ["all", "chiffre_affaireS"],
          },
        ],
      },*/

  {
    category: true,
    title: "menu.finance",
    key: "finance",
    accessGroup: "tresorerie",
    buildingAccess: "tresorerie",

    access: [
      "all",
      "caisse_management",
      "my_caisse",
      "cheque_traite_tab",
      "stat_tab",
      "borderaux_tab",
      "reglement_annule",
      "etat_impayes",
      "etat_recettes",
    ],
  },
  {
    title: "menu.tresorerie",
    key: "tresorerie",
    accessGroup: "tresorerie",
    buildingAccess: "tresorerie",
    icon: "fa fa-university",
    access: [
      "all",
      "caisse_management",
      "my_caisse",
      "cheque_traite_tab",
      "stat_tab",
      "borderaux_tab",
      "reglement_annule",
    ],
    children: [
      {
        title: "menu.manageCaisses",
        key: "manageCaisses",
        accessGroup: "tresorerie",
        buildingAccess: "tresorerie",

        url: "/manageCaisses",
        icon: "fa fa-cogs",
        access: ["all", "caisse_management"],
      },
      {
        title: "menu.myCaisse",
        key: "myCaisse",
        accessGroup: "tresorerie",
        buildingAccess: "tresorerie",

        url: "/myCaisse",
        icon: "fa fa-bank",
        access: ["all", "my_caisse"],
      },
      {
        title: "menu.chequeEtTraite",
        key: "chequeEtTraite",
        accessGroup: "tresorerie",
        buildingAccess: "tresorerie",

        url: "/chequeEtTraite",
        icon: "fa fa-credit-card",
        access: ["all", "cheque_traite_tab", "stat_tab", "borderaux_tab"],
      },
      {
        title: "menu.reglementsAnnules",
        key: "reglementsAnnulesv3",
        accessGroup: "tresorerie",
        buildingAccess: "tresorerie",

        url: "/reglementsAnnules",
        icon: "fa fa-times-circle",
        access: ["all", "reglement_annule"],
      },
    ],
  },
  {
    title: "menu.encaissement",
    key: "encaissement",
    accessGroup: "encaissement",
    buildingAccess: "encaissement",
    icon: "fa fa-money",
    access: [
      "all",
      "etat_impayes",
      "etat_recettes",
    ],
    children: [
      {
        title: "menu.etatRecettes",
        key: "etatRecettesV3",
        accessGroup: "encaissement",
        buildingAccess: "encaissement",

        url: "/encaissement/etatDesRecettes",
        icon: "fa fa-list",
        access: ["all", "etat_recettes"],
      },
      {
        title: "menu.etatImpayes",
        key: "etatImpayesV3",
        accessGroup: "encaissement",
        buildingAccess: "encaissement",

        url: "/encaissement/etatDesImpayes",
        icon: "fa fa-exclamation-circle",
        access: ["all", "etat_impayes"],
      },
      {
        title: "menu.caisseAvance",
        key: "avance",
        accessGroup: "encaissement",
        buildingAccess: "encaissement",

        url: "/caisseavance",
        icon: "fa fa-money",
        access: ["all", "etat_recettes"],
      },

    ],
  },
  {
    title: "menu.decaissement",
    key: "decaissement",
    accessGroup: "decaissement",

    icon: "fa fa-money",
    access: [
      "all",
      "depense",
      "liste_depenses",
      "nouvelle_depense",
      "fournisseurs",
      "saisie_paiement",
      "historique_paiements",
      "validation_reception",
      "reconciliation",
      "avoir_fournisseur",
      "dettes",
    ],
    buildingAccess: "decaissement",

    children: [
      {
        title: "menu.nouvelleDepense",
        key: "nouvelleDepense",
        accessGroup: "decaissement",
        buildingAccess: "decaissement",
        url: "/decaissement/nouvelle-depense",
        icon: "fa fa-plus-square",
        access: ["all", "depense", "nouvelle_depense"],
      },
      {
        title: "menu.fournisseurs",
        key: "fournisseurs",
        accessGroup: "decaissement",
        buildingAccess: "decaissement",
        url: "/decaissement/fournisseurs",
        icon: "fa fa-building",
        access: ["all", "depense", "fournisseurs"],
      },
      {
        title: "menu.saisiePaiement",
        key: "saisiePaiement",
        accessGroup: "decaissement",
        buildingAccess: "decaissement",
        url: "/decaissement/saisie-paiement",
        icon: "fa fa-credit-card",
        access: ["all", "depense", "saisie_paiement"],
      },
      {
        title: "menu.historiquePaiements",
        key: "historiquePaiements",
        accessGroup: "decaissement",
        buildingAccess: "decaissement",
        url: "/decaissement/historique-paiements",
        icon: "fa fa-history",
        access: ["all", "depense", "historique_paiements"],
      },
      {
        title: "menu.encaissementValidation",
        key: "encaissementValidation",
        accessGroup: "decaissement",
        buildingAccess: "decaissement",
        url: "/decaissement/validation-reception",
        icon: "fa fa-check-circle",
        access: ["all", "depense", "validation_reception"],
      },
      {
        title: "menu.reconciliation",
        key: "reconciliation",
        accessGroup: "decaissement",
        buildingAccess: "decaissement",
        url: "/decaissement/reconciliation",
        icon: "fa fa-check-square",
        access: ["all", "depense", "reconciliation"],
      },
      {
        title: "menu.avoirFournisseur",
        key: "avoirFournisseur",
        accessGroup: "decaissement",
        buildingAccess: "decaissement",
        url: "/decaissement/avoir-fournisseur",
        icon: "fa fa-undo",
        access: ["all", "depense", "avoir_fournisseur"],
      },
      {
        title: "menu.dettes",
        key: "dettes",
        accessGroup: "decaissement",
        buildingAccess: "decaissement",
        url: "/decaissement/dettes",
        icon: "fa fa-university",
        access: ["all", "depense", "dettes"],
      },
    ],
  },
  {
    category: true,
    title: "menu.actulite",
    key: "actualite",
    accessGroup: "actualite",
    access: ["actualite", "all"],
    buildingAccess: "news",
  },
  {
    title: "menu.actulite",
    key: "actualite",

    accessGroup: "actualite",
    icon: "fa fa-newspaper-o",
    url: "/actuality",
    access: ["all", "actualite"],
    buildingAccess: "news",
  },
  {
    category: true,
    title: "menu.calender",
    key: "calendar",
    accessGroup: "calendar",
    access: ["calendar", "all"],
    buildingAccess: "calender",
  },
  {
    title: "menu.calender",
    key: "calendar",
    accessGroup: "calendar",
    icon: "fa fa-calendar",
    url: "/calender",
    access: ["all", "calendar"],
    buildingAccess: "calender",
  },
  {
    category: true,
    title: "menu.sms",
    key: "sms",
    accessGroup: "sms",
    access: ["all", "sms"],
    buildingAccess: "sms",
  },
  {
    title: "menu.sms",
    key: "sms",

    accessGroup: "sms",
    icon: "fa fa-envelope",
    access: ["all", "sms", "history"],
    buildingAccess: "sms",

    children: [
      {
        title: "menu.envoyerSms",
        key: "send",
        accessGroup: "sms",
        buildingAccess: "sms",
        url: "/sms/envoyer",
        icon: "fa fa-envelope-open",
        access: ["all", "send"],
      },
      {
        title: "menu.envoyerParClasseSms",
        key: "sendClass",
        accessGroup: "sms",
        buildingAccess: "sms",
        url: "/sms/envoyerClasse",
        icon: "fa fa-envelope-open",
        access: ["all", "send"],
      },
      {
        title: "menu.envoyerSmsLogin",
        key: "sendLogin",
        accessGroup: "sms",
        buildingAccess: "sms",
        url: "/sms/envoyerLogin",
        icon: "fa fa-lock",
        access: ["all", "send"],
      },
      {
        title: "menu.historiqueSms",
        key: "history",
        accessGroup: "sms",
        buildingAccess: "sms",
        url: "/sms/historique",
        icon: "fa fa-inbox",
        access: ["all", "history"],
      },
    ],
  },

  {
    category: true,
    title: "menu.supervision",
    key: "supervision",
    accessGroup: "supervision",
    access: ["supervision", "all"],
    buildingAccess: "ptchat",
  },
  {
    title: "menu.ptchat",
    key: "ptchat",
    accessGroup: "supervision",
    icon: "fa fa-weixin",
    url: "/ptchat",
    access: ["all", "ptchat"],
    buildingAccess: "ptchat",
  },

  {
    category: true,
    title: "menu.degital_library",
    key: "degital_library",
    accessGroup: "digitalLibrary",
    access: ["all", "digitalLibrary"],
    buildingAccess: "digitalLibrary",
  },
  {
    title: "menu.degital_library_list",
    key: "degital_library_list",
    accessGroup: "digitalLibrary",
    icon: "fa fa-book",
    url: "/degital_library",
    access: ["all", "digitalLibrary"],
    buildingAccess: "digitalLibrary",
  },
  {
    category: true,
    title: "menu.marketPlace",
    key: "marketPlace",
    accessGroup: "marketPlace",
    access: ["marketPlace", "all"],
    buildingAccess: "marketPlace",
  },
  {
    title: "menu.marketproducts_list",
    key: "marketproducts_list",
    accessGroup: "marketPlace",
    icon: "fa fa-shopping-cart",
    url: "/marketPlace",
    access: ["all", "marketPlace"],
    buildingAccess: "marketPlace",
  },
];
